import { IApplicationState, TBoardId } from '../../../types/types';
import { IChatDashboardSettings } from '../chatDashboardSettings/types';
import { getChatDashboardSettingsByBoardId } from 'app/store/model/chatDashboardSettings/selectors/getChatDashboardSettingsByBoardId';

export const getChatDashboardSettingsForRollback = (
    state: IApplicationState,
    boardId: TBoardId,
    patchChatDashboardSettings: IChatDashboardSettings
): IChatDashboardSettings => {
    const chatDashboardSettings = getChatDashboardSettingsByBoardId(state, boardId);
    if (!patchChatDashboardSettings || !chatDashboardSettings) return;
    let chatDashboardSettingsForRollback: IChatDashboardSettings = {};
    for (const field in patchChatDashboardSettings) {
        const fieldKey = field as keyof IChatDashboardSettings;
        chatDashboardSettingsForRollback = {
            ...chatDashboardSettingsForRollback,
            [fieldKey]: chatDashboardSettings[fieldKey]
        };
    }

    return JSON.parse(JSON.stringify(chatDashboardSettingsForRollback));
}
